import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogTrigger } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { GripVertical, X, Plus, Trash2, Check, ChevronsUpDown, Zap, DollarSign, Calendar, User, Building, MapPin, CalendarDays, Info, Settings, Home, Phone, Mail, Clock, Star, Target, TrendingUp, Shield, Award, Gift, Heart, Eye, Search, Filter, Grid, List, BarChart3, PieChart, Activity, AlertCircle, CheckCircle, XCircle, MinusCircle, PlusCircle, Edit, Copy, Download, Upload, Share, Lock, Unlock, Key, Database, Server, Cloud, Wifi, Bluetooth, Battery, Power, Volume, Camera, Video, Music, File, Folder, Book, Newspaper, Briefcase, ShoppingBag, ShoppingCart, CreditCard, Banknote, Coins, PiggyBank, Calculator, Scale, Thermometer, Droplets, Sun, Moon, CloudRain, CloudSnow, Wind, Umbrella, Trees, Leaf, Flower, Car, Truck, Bike, Plane, Ship, Train, Bus, Rocket, Satellite, Wrench, Hammer, Drill, Paintbrush, Palette, Brush, Pen, Pencil, Highlighter, Eraser, Scissors, Paperclip, Link, Unlink, ExternalLink, DownloadCloud, UploadCloud, RefreshCw, RotateCcw, RotateCw, ZoomIn, ZoomOut, Maximize, Minimize, Move, Crop, Type, Bold, Italic, Underline, Strikethrough, Code, Hash, AtSign, Percent, Minus, Divide, Equal, Infinity, Pi, Sigma, Omega } from 'lucide-react';
import { DragDropContext, Droppable, Draggable, DropResult } from '@hello-pangea/dnd';
import { Card, CardContent } from '@/components/ui/card';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { formatAddress } from '@/utils/formatAddress';
import { Select, SelectContent, SelectTrigger, SelectValue, SelectItem } from '@/components/ui/select';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem } from '@/components/ui/command';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useToast } from '@/components/ui/use-toast';
import { supabase } from '@/lib/supabase';
import { cn } from '@/lib/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as FaSolidIcons from '@fortawesome/free-solid-svg-icons';
import { 
  FiZap, FiDollarSign, FiCalendar, FiUser, FiHome, FiSettings, FiInfo, FiStar, FiHeart, FiEye, FiSearch, FiFilter, FiGrid, FiList, FiBarChart, FiPieChart, FiActivity, FiAlertCircle, FiCheckCircle, FiXCircle, FiEdit, FiCopy, FiDownload, FiUpload, FiShare, FiLock, FiUnlock, FiKey, FiDatabase, FiServer, FiCloud, FiWifi, FiBattery, FiPower, FiCamera, FiVideo, FiMusic, FiFile, FiFolder, FiLink, FiExternalLink, FiMail, FiPhone, FiClock, FiTarget, FiTrendingUp, FiShield, FiAward, FiGift, FiBriefcase, FiCreditCard, FiSun, FiMoon, FiTruck, FiScissors, FiPaperclip, FiRefreshCw, FiZoomIn, FiZoomOut, FiMaximize, FiMinimize, FiMove, FiType, FiBold, FiItalic, FiCode, FiHash, FiAtSign, FiPercent, FiMinus, FiPlus, FiDivide
} from 'react-icons/fi';
import { 
  HiOutlineLightningBolt, HiOutlineCurrencyDollar, HiOutlineCalendar, HiOutlineUser, HiOutlineHome, HiOutlineCog, HiOutlineInformationCircle, HiOutlineStar, HiOutlineHeart, HiOutlineEye, HiOutlineSearch, HiOutlineFilter, HiOutlineViewGrid, HiOutlineViewList, HiOutlineChartBar, HiOutlineChartPie, HiOutlineExclamationCircle, HiOutlineCheckCircle, HiOutlineXCircle, HiOutlinePencil, HiOutlineDuplicate, HiOutlineDownload, HiOutlineUpload, HiOutlineShare, HiOutlineLockClosed, HiOutlineKey, HiOutlineDatabase, HiOutlineServer, HiOutlineCloud, HiOutlineWifi, HiOutlineLightBulb, HiOutlineCamera, HiOutlineVideoCamera, HiOutlineMusicNote, HiOutlineDocument, HiOutlineFolder, HiOutlineLink, HiOutlineExternalLink, HiOutlineMail, HiOutlinePhone, HiOutlineClock, HiOutlineTrendingUp, HiOutlineShieldCheck, HiOutlineBadgeCheck, HiOutlineGift, HiOutlineBriefcase, HiOutlineCreditCard, HiOutlineCalculator, HiOutlineSun, HiOutlineMoon, HiOutlineTruck, HiOutlinePaperAirplane, HiOutlineScissors, HiOutlinePaperClip, HiOutlineRefresh, HiOutlineZoomIn, HiOutlineZoomOut, HiOutlineArrowsExpand, HiOutlineDocumentText, HiOutlineCode, HiOutlineHashtag, HiOutlineAtSymbol, HiOutlineMinus, HiOutlinePlus, HiOutlineX, HiOutlineCheck
} from 'react-icons/hi';
import { 
  MdOutlineFlashOn, MdOutlineAttachMoney, MdOutlineCalendarToday, MdOutlinePerson, MdOutlineHome, MdOutlineSettings, MdOutlineInfo, MdOutlineStar, MdOutlineFavorite, MdOutlineVisibility, MdOutlineSearch, MdOutlineFilterList, MdOutlineGridView, MdOutlineViewList, MdOutlineBarChart, MdOutlinePieChart, MdOutlineTrendingUp, MdOutlineError, MdOutlineCheckCircle, MdOutlineCancel, MdOutlineEdit, MdOutlineContentCopy, MdOutlineDownload, MdOutlineUpload, MdOutlineShare, MdOutlineLock, MdOutlineKey, MdOutlineStorage, MdOutlineDns, MdOutlineCloud, MdOutlineWifi, MdOutlineBattery6Bar, MdOutlineLightbulb, MdOutlineCameraAlt, MdOutlineVideocam, MdOutlineMusicNote, MdOutlineDescription, MdOutlineFolder, MdOutlineLink, MdOutlineOpenInNew, MdOutlineEmail, MdOutlinePhone, MdOutlineAccessTime, MdOutlineGpsFixed, MdOutlineSecurity, MdOutlineWorkspacePremium, MdOutlineCardGiftcard, MdOutlineWork, MdOutlineCreditCard, MdOutlineCalculate, MdOutlineWbSunny, MdOutlineNightlight, MdOutlineDirectionsCar, MdOutlineLocalShipping, MdOutlineFlight, MdOutlineBuild, MdOutlineCreate, MdOutlineContentCut, MdOutlineAttachFile, MdOutlineRefresh, MdOutlineZoomIn, MdOutlineZoomOut, MdOutlineOpenInFull, MdOutlineCloseFullscreen, MdOutlineDragIndicator, MdOutlineTextFields, MdOutlineCode, MdOutlineTag, MdOutlineAlternateEmail, MdOutlineRemove, MdOutlineAdd, MdOutlineClose, MdOutlineDone
} from 'react-icons/md';
import { 
  BsLightning, BsCurrencyDollar, BsCalendar, BsPerson, BsHouse, BsGear, BsInfoCircle, BsStar, BsHeart, BsEye, BsSearch, BsFilter, BsGrid, BsList, BsBarChart, BsPieChart, BsExclamationCircle, BsCheckCircle, BsXCircle, BsPencil, BsCopy, BsDownload, BsUpload, BsShare, BsLock, BsKey, BsDatabase, BsServer, BsCloud, BsWifi, BsBatteryHalf, BsLightbulb, BsCamera, BsCameraVideo, BsMusicNote, BsFileText, BsFolder, BsLink, BsBoxArrowUpRight, BsEnvelope, BsTelephone, BsClock, BsGraphUp, BsShield, BsAward, BsGift, BsBriefcase, BsCreditCard, BsCalculator, BsSun, BsMoon, BsCarFront, BsTruck, BsAirplane, BsPen, BsScissors, BsPaperclip, BsArrowClockwise, BsZoomIn, BsZoomOut, BsArrowsFullscreen, BsType, BsCode, BsHash, BsAt, BsDash, BsPlus, BsX, BsCheck
} from 'react-icons/bs';

const AVAILABLE_FIELDS = [
  { field: 'system_size', label: 'System Size', icon: 'zap' },
  { field: 'project_value', label: 'Project Value', icon: 'dollar-sign' },
  { field: 'days_in_stage', label: 'Days in Stage', icon: 'calendar' },
  { field: 'name', label: 'Project Name', icon: 'user' },
  { field: 'company', label: 'Company', icon: 'building' },
  { field: 'city', label: 'City', icon: 'map-pin' },
  { field: 'state', label: 'State', icon: 'map-pin' },
  { field: 'booking_date_time', label: 'Booking Date', icon: 'calendar-days' },
];

const FA_ICONS = Object.entries(FaSolidIcons)
  .filter(([key]) => key.startsWith('fa'))
  .map(([key, icon]) => ({
    value: key,
    label: key.replace(/^fa/, '').replace(/([A-Z])/g, ' $1').trim(),
    icon: icon as any,
  }));

const LUCIDE_ICONS = [
  { value: 'zap', label: 'Lightning', icon: Zap },
  { value: 'dollar-sign', label: 'Dollar', icon: DollarSign },
  { value: 'calendar', label: 'Calendar', icon: Calendar },
  { value: 'user', label: 'User', icon: User },
  { value: 'building', label: 'Building', icon: Building },
  { value: 'map-pin', label: 'Map Pin', icon: MapPin },
  { value: 'calendar-days', label: 'Calendar Days', icon: CalendarDays },
  { value: 'info', label: 'Info', icon: Info },
  { value: 'settings', label: 'Settings', icon: Settings },
  { value: 'home', label: 'Home', icon: Home },
  { value: 'phone', label: 'Phone', icon: Phone },
  { value: 'mail', label: 'Mail', icon: Mail },
  { value: 'clock', label: 'Clock', icon: Clock },
  { value: 'star', label: 'Star', icon: Star },
  { value: 'target', label: 'Target', icon: Target },
  { value: 'trending-up', label: 'Trending Up', icon: TrendingUp },
  { value: 'shield', label: 'Shield', icon: Shield },
  { value: 'award', label: 'Award', icon: Award },
  { value: 'gift', label: 'Gift', icon: Gift },
  { value: 'heart', label: 'Heart', icon: Heart },
  { value: 'eye', label: 'Eye', icon: Eye },
  { value: 'search', label: 'Search', icon: Search },
  { value: 'filter', label: 'Filter', icon: Filter },
  { value: 'grid', label: 'Grid', icon: Grid },
  { value: 'list', label: 'List', icon: List },
  { value: 'bar-chart-3', label: 'Bar Chart', icon: BarChart3 },
  { value: 'pie-chart', label: 'Pie Chart', icon: PieChart },
  { value: 'activity', label: 'Activity', icon: Activity },
  { value: 'alert-circle', label: 'Alert Circle', icon: AlertCircle },
  { value: 'check-circle', label: 'Check Circle', icon: CheckCircle },
  { value: 'x-circle', label: 'X Circle', icon: XCircle },
  { value: 'minus-circle', label: 'Minus Circle', icon: MinusCircle },
  { value: 'plus-circle', label: 'Plus Circle', icon: PlusCircle },
  { value: 'edit', label: 'Edit', icon: Edit },
  { value: 'copy', label: 'Copy', icon: Copy },
  { value: 'download', label: 'Download', icon: Download },
  { value: 'upload', label: 'Upload', icon: Upload },
  { value: 'share', label: 'Share', icon: Share },
  { value: 'lock', label: 'Lock', icon: Lock },
  { value: 'unlock', label: 'Unlock', icon: Unlock },
  { value: 'key', label: 'Key', icon: Key },
  { value: 'database', label: 'Database', icon: Database },
  { value: 'server', label: 'Server', icon: Server },
  { value: 'cloud', label: 'Cloud', icon: Cloud },
  { value: 'wifi', label: 'WiFi', icon: Wifi },
  { value: 'bluetooth', label: 'Bluetooth', icon: Bluetooth },
  { value: 'battery', label: 'Battery', icon: Battery },
  { value: 'power', label: 'Power', icon: Power },
  { value: 'volume', label: 'Volume', icon: Volume },
  { value: 'camera', label: 'Camera', icon: Camera },
  { value: 'video', label: 'Video', icon: Video },
  { value: 'music', label: 'Music', icon: Music },
  { value: 'file', label: 'File', icon: File },
  { value: 'folder', label: 'Folder', icon: Folder },
  { value: 'book', label: 'Book', icon: Book },
  { value: 'newspaper', label: 'Newspaper', icon: Newspaper },
  { value: 'briefcase', label: 'Briefcase', icon: Briefcase },
  { value: 'shopping-bag', label: 'Shopping Bag', icon: ShoppingBag },
  { value: 'shopping-cart', label: 'Shopping Cart', icon: ShoppingCart },
  { value: 'credit-card', label: 'Credit Card', icon: CreditCard },
  { value: 'banknote', label: 'Banknote', icon: Banknote },
  { value: 'coins', label: 'Coins', icon: Coins },
  { value: 'piggy-bank', label: 'Piggy Bank', icon: PiggyBank },
  { value: 'calculator', label: 'Calculator', icon: Calculator },
  { value: 'scale', label: 'Scale', icon: Scale },
  { value: 'thermometer', label: 'Thermometer', icon: Thermometer },
  { value: 'droplets', label: 'Droplets', icon: Droplets },
  { value: 'sun', label: 'Sun', icon: Sun },
  { value: 'moon', label: 'Moon', icon: Moon },
  { value: 'cloud-rain', label: 'Cloud Rain', icon: CloudRain },
  { value: 'cloud-snow', label: 'Cloud Snow', icon: CloudSnow },
  { value: 'wind', label: 'Wind', icon: Wind },
  { value: 'umbrella', label: 'Umbrella', icon: Umbrella },
  { value: 'trees', label: 'Trees', icon: Trees },
  { value: 'leaf', label: 'Leaf', icon: Leaf },
  { value: 'flower', label: 'Flower', icon: Flower },
  { value: 'car', label: 'Car', icon: Car },
  { value: 'truck', label: 'Truck', icon: Truck },
  { value: 'bike', label: 'Bike', icon: Bike },
  { value: 'plane', label: 'Plane', icon: Plane },
  { value: 'ship', label: 'Ship', icon: Ship },
  { value: 'train', label: 'Train', icon: Train },
  { value: 'bus', label: 'Bus', icon: Bus },
  { value: 'rocket', label: 'Rocket', icon: Rocket },
  { value: 'satellite', label: 'Satellite', icon: Satellite },
  { value: 'wrench', label: 'Wrench', icon: Wrench },
  { value: 'hammer', label: 'Hammer', icon: Hammer },
  { value: 'drill', label: 'Drill', icon: Drill },
  { value: 'paintbrush', label: 'Paintbrush', icon: Paintbrush },
  { value: 'palette', label: 'Palette', icon: Palette },
  { value: 'brush', label: 'Brush', icon: Brush },
  { value: 'pen', label: 'Pen', icon: Pen },
  { value: 'pencil', label: 'Pencil', icon: Pencil },
  { value: 'highlighter', label: 'Highlighter', icon: Highlighter },
  { value: 'eraser', label: 'Eraser', icon: Eraser },
  { value: 'scissors', label: 'Scissors', icon: Scissors },
  { value: 'paperclip', label: 'Paperclip', icon: Paperclip },
  { value: 'link', label: 'Link', icon: Link },
  { value: 'unlink', label: 'Unlink', icon: Unlink },
  { value: 'external-link', label: 'External Link', icon: ExternalLink },
  { value: 'download-cloud', label: 'Download Cloud', icon: DownloadCloud },
  { value: 'upload-cloud', label: 'Upload Cloud', icon: UploadCloud },
  { value: 'refresh-cw', label: 'Refresh CW', icon: RefreshCw },
  { value: 'rotate-ccw', label: 'Rotate CCW', icon: RotateCcw },
  { value: 'rotate-cw', label: 'Rotate CW', icon: RotateCw },
  { value: 'zoom-in', label: 'Zoom In', icon: ZoomIn },
  { value: 'zoom-out', label: 'Zoom Out', icon: ZoomOut },
  { value: 'maximize', label: 'Maximize', icon: Maximize },
  { value: 'minimize', label: 'Minimize', icon: Minimize },
  { value: 'move', label: 'Move', icon: Move },
  { value: 'crop', label: 'Crop', icon: Crop },
  { value: 'type', label: 'Type', icon: Type },
  { value: 'bold', label: 'Bold', icon: Bold },
  { value: 'italic', label: 'Italic', icon: Italic },
  { value: 'underline', label: 'Underline', icon: Underline },
  { value: 'strikethrough', label: 'Strikethrough', icon: Strikethrough },
  { value: 'code', label: 'Code', icon: Code },
  { value: 'hash', label: 'Hash', icon: Hash },
  { value: 'at-sign', label: 'At Sign', icon: AtSign },
  { value: 'percent', label: 'Percent', icon: Percent },
  { value: 'minus', label: 'Minus', icon: Minus },
  { value: 'divide', label: 'Divide', icon: Divide },
  { value: 'equal', label: 'Equal', icon: Equal },
  { value: 'infinity', label: 'Infinity', icon: Infinity },
  { value: 'pi', label: 'Pi', icon: Pi },
  { value: 'sigma', label: 'Sigma', icon: Sigma },
  { value: 'omega', label: 'Omega', icon: Omega },
];

const REACT_ICONS = [
  // Feather Icons
  { value: 'fi-zap', label: 'Zap', icon: FiZap, library: 'feather' },
  { value: 'fi-dollar-sign', label: 'Dollar', icon: FiDollarSign, library: 'feather' },
  { value: 'fi-calendar', label: 'Calendar', icon: FiCalendar, library: 'feather' },
  { value: 'fi-user', label: 'User', icon: FiUser, library: 'feather' },
  { value: 'fi-home', label: 'Home', icon: FiHome, library: 'feather' },
  { value: 'fi-settings', label: 'Settings', icon: FiSettings, library: 'feather' },
  { value: 'fi-info', label: 'Info', icon: FiInfo, library: 'feather' },
  { value: 'fi-star', label: 'Star', icon: FiStar, library: 'feather' },
  { value: 'fi-heart', label: 'Heart', icon: FiHeart, library: 'feather' },
  { value: 'fi-eye', label: 'Eye', icon: FiEye, library: 'feather' },
  { value: 'fi-search', label: 'Search', icon: FiSearch, library: 'feather' },
  { value: 'fi-filter', label: 'Filter', icon: FiFilter, library: 'feather' },
  { value: 'fi-grid', label: 'Grid', icon: FiGrid, library: 'feather' },
  { value: 'fi-list', label: 'List', icon: FiList, library: 'feather' },
  { value: 'fi-bar-chart-3', label: 'Bar Chart', icon: FiBarChart, library: 'feather' },
  { value: 'fi-pie-chart', label: 'Pie Chart', icon: FiPieChart, library: 'feather' },
  { value: 'fi-activity', label: 'Activity', icon: FiActivity, library: 'feather' },
  { value: 'fi-alert-circle', label: 'Alert', icon: FiAlertCircle, library: 'feather' },
  { value: 'fi-check-circle', label: 'Check', icon: FiCheckCircle, library: 'feather' },
  { value: 'fi-x-circle', label: 'X Circle', icon: FiXCircle, library: 'feather' },
  { value: 'fi-edit', label: 'Edit', icon: FiEdit, library: 'feather' },
  { value: 'fi-copy', label: 'Copy', icon: FiCopy, library: 'feather' },
  { value: 'fi-download', label: 'Download', icon: FiDownload, library: 'feather' },
  { value: 'fi-upload', label: 'Upload', icon: FiUpload, library: 'feather' },
  { value: 'fi-share', label: 'Share', icon: FiShare, library: 'feather' },
  { value: 'fi-lock', label: 'Lock', icon: FiLock, library: 'feather' },
  { value: 'fi-unlock', label: 'Unlock', icon: FiUnlock, library: 'feather' },
  { value: 'fi-key', label: 'Key', icon: FiKey, library: 'feather' },
  { value: 'fi-database', label: 'Database', icon: FiDatabase, library: 'feather' },
  { value: 'fi-server', label: 'Server', icon: FiServer, library: 'feather' },
  { value: 'fi-cloud', label: 'Cloud', icon: FiCloud, library: 'feather' },
  { value: 'fi-wifi', label: 'WiFi', icon: FiWifi, library: 'feather' },
  { value: 'fi-battery', label: 'Battery', icon: FiBattery, library: 'feather' },
  { value: 'fi-power', label: 'Power', icon: FiPower, library: 'feather' },
  { value: 'fi-camera', label: 'Camera', icon: FiCamera, library: 'feather' },
  { value: 'fi-video', label: 'Video', icon: FiVideo, library: 'feather' },
  { value: 'fi-music', label: 'Music', icon: FiMusic, library: 'feather' },
  { value: 'fi-file', label: 'File', icon: FiFile, library: 'feather' },
  { value: 'fi-folder', label: 'Folder', icon: FiFolder, library: 'feather' },
  { value: 'fi-link', label: 'Link', icon: FiLink, library: 'feather' },
  { value: 'fi-external-link', label: 'External Link', icon: FiExternalLink, library: 'feather' },
  { value: 'fi-mail', label: 'Mail', icon: FiMail, library: 'feather' },
  { value: 'fi-phone', label: 'Phone', icon: FiPhone, library: 'feather' },
  { value: 'fi-clock', label: 'Clock', icon: FiClock, library: 'feather' },
  { value: 'fi-target', label: 'Target', icon: FiTarget, library: 'feather' },
  { value: 'fi-trending-up', label: 'Trending Up', icon: FiTrendingUp, library: 'feather' },
  { value: 'fi-shield', label: 'Shield', icon: FiShield, library: 'feather' },
  { value: 'fi-award', label: 'Award', icon: FiAward, library: 'feather' },
  { value: 'fi-gift', label: 'Gift', icon: FiGift, library: 'feather' },
  { value: 'fi-briefcase', label: 'Briefcase', icon: FiBriefcase, library: 'feather' },
  { value: 'fi-credit-card', label: 'Credit Card', icon: FiCreditCard, library: 'feather' },
  { value: 'fi-sun', label: 'Sun', icon: FiSun, library: 'feather' },
  { value: 'fi-moon', label: 'Moon', icon: FiMoon, library: 'feather' },
  { value: 'fi-truck', label: 'Truck', icon: FiTruck, library: 'feather' },
  { value: 'fi-scissors', label: 'Scissors', icon: FiScissors, library: 'feather' },
  { value: 'fi-paperclip', label: 'Paperclip', icon: FiPaperclip, library: 'feather' },
  { value: 'fi-refresh-cw', label: 'Refresh', icon: FiRefreshCw, library: 'feather' },
  { value: 'fi-zoom-in', label: 'Zoom In', icon: FiZoomIn, library: 'feather' },
  { value: 'fi-zoom-out', label: 'Zoom Out', icon: FiZoomOut, library: 'feather' },
  { value: 'fi-maximize', label: 'Maximize', icon: FiMaximize, library: 'feather' },
  { value: 'fi-minimize', label: 'Minimize', icon: FiMinimize, library: 'feather' },
  { value: 'fi-move', label: 'Move', icon: FiMove, library: 'feather' },
  { value: 'fi-type', label: 'Type', icon: FiType, library: 'feather' },
  { value: 'fi-bold', label: 'Bold', icon: FiBold, library: 'feather' },
  { value: 'fi-italic', label: 'Italic', icon: FiItalic, library: 'feather' },
  { value: 'fi-code', label: 'Code', icon: FiCode, library: 'feather' },
  { value: 'fi-hash', label: 'Hash', icon: FiHash, library: 'feather' },
  { value: 'fi-at-sign', label: 'At Sign', icon: FiAtSign, library: 'feather' },
  { value: 'fi-percent', label: 'Percent', icon: FiPercent, library: 'feather' },
  { value: 'fi-minus', label: 'Minus', icon: FiMinus, library: 'feather' },
  { value: 'fi-plus', label: 'Plus', icon: FiPlus, library: 'feather' },
  { value: 'fi-divide', label: 'Divide', icon: FiDivide, library: 'feather' },
  
  // Heroicons
  { value: 'hi-zap', label: 'Zap', icon: HiOutlineLightningBolt, library: 'heroicons' },
  { value: 'hi-currency-dollar', label: 'Dollar', icon: HiOutlineCurrencyDollar, library: 'heroicons' },
  { value: 'hi-calendar', label: 'Calendar', icon: HiOutlineCalendar, library: 'heroicons' },
  { value: 'hi-user', label: 'User', icon: HiOutlineUser, library: 'heroicons' },
  { value: 'hi-home', label: 'Home', icon: HiOutlineHome, library: 'heroicons' },
  { value: 'hi-cog', label: 'Settings', icon: HiOutlineCog, library: 'heroicons' },
  { value: 'hi-information-circle', label: 'Info', icon: HiOutlineInformationCircle, library: 'heroicons' },
  { value: 'hi-star', label: 'Star', icon: HiOutlineStar, library: 'heroicons' },
  { value: 'hi-heart', label: 'Heart', icon: HiOutlineHeart, library: 'heroicons' },
  { value: 'hi-eye', label: 'Eye', icon: HiOutlineEye, library: 'heroicons' },
  { value: 'hi-search', label: 'Search', icon: HiOutlineSearch, library: 'heroicons' },
  { value: 'hi-filter', label: 'Filter', icon: HiOutlineFilter, library: 'heroicons' },
  { value: 'hi-view-grid', label: 'Grid', icon: HiOutlineViewGrid, library: 'heroicons' },
  { value: 'hi-view-list', label: 'List', icon: HiOutlineViewList, library: 'heroicons' },
  { value: 'hi-chart-bar', label: 'Bar Chart', icon: HiOutlineChartBar, library: 'heroicons' },
  { value: 'hi-chart-pie', label: 'Pie Chart', icon: HiOutlineChartPie, library: 'heroicons' },
  { value: 'hi-lightning-bolt', label: 'Lightning', icon: HiOutlineLightningBolt, library: 'heroicons' },
  { value: 'hi-exclamation-circle', label: 'Alert', icon: HiOutlineExclamationCircle, library: 'heroicons' },
  { value: 'hi-check-circle', label: 'Check', icon: HiOutlineCheckCircle, library: 'heroicons' },
  { value: 'hi-x-circle', label: 'X Circle', icon: HiOutlineXCircle, library: 'heroicons' },
  { value: 'hi-pencil', label: 'Edit', icon: HiOutlinePencil, library: 'heroicons' },
  { value: 'hi-duplicate', label: 'Copy', icon: HiOutlineDuplicate, library: 'heroicons' },
  { value: 'hi-download', label: 'Download', icon: HiOutlineDownload, library: 'heroicons' },
  { value: 'hi-upload', label: 'Upload', icon: HiOutlineUpload, library: 'heroicons' },
  { value: 'hi-share', label: 'Share', icon: HiOutlineShare, library: 'heroicons' },
  { value: 'hi-lock-closed', label: 'Lock', icon: HiOutlineLockClosed, library: 'heroicons' },
  { value: 'hi-key', label: 'Key', icon: HiOutlineKey, library: 'heroicons' },
  { value: 'hi-database', label: 'Database', icon: HiOutlineDatabase, library: 'heroicons' },
  { value: 'hi-server', label: 'Server', icon: HiOutlineServer, library: 'heroicons' },
  { value: 'hi-cloud', label: 'Cloud', icon: HiOutlineCloud, library: 'heroicons' },
  { value: 'hi-wifi', label: 'WiFi', icon: HiOutlineWifi, library: 'heroicons' },
  { value: 'hi-light-bulb', label: 'Light Bulb', icon: HiOutlineLightBulb, library: 'heroicons' },
  { value: 'hi-camera', label: 'Camera', icon: HiOutlineCamera, library: 'heroicons' },
  { value: 'hi-video-camera', label: 'Video', icon: HiOutlineVideoCamera, library: 'heroicons' },
  { value: 'hi-music-note', label: 'Music', icon: HiOutlineMusicNote, library: 'heroicons' },
  { value: 'hi-document', label: 'Document', icon: HiOutlineDocument, library: 'heroicons' },
  { value: 'hi-folder', label: 'Folder', icon: HiOutlineFolder, library: 'heroicons' },
  { value: 'hi-link', label: 'Link', icon: HiOutlineLink, library: 'heroicons' },
  { value: 'hi-external-link', label: 'External Link', icon: HiOutlineExternalLink, library: 'heroicons' },
  { value: 'hi-mail', label: 'Mail', icon: HiOutlineMail, library: 'heroicons' },
  { value: 'hi-phone', label: 'Phone', icon: HiOutlinePhone, library: 'heroicons' },
  { value: 'hi-clock', label: 'Clock', icon: HiOutlineClock, library: 'heroicons' },
  { value: 'hi-trending-up', label: 'Trending Up', icon: HiOutlineTrendingUp, library: 'heroicons' },
  { value: 'hi-badge-check', label: 'Award', icon: HiOutlineBadgeCheck, library: 'heroicons' },
  { value: 'hi-gift', label: 'Gift', icon: HiOutlineGift, library: 'heroicons' },
  { value: 'hi-briefcase', label: 'Briefcase', icon: HiOutlineBriefcase, library: 'heroicons' },
  { value: 'hi-credit-card', label: 'Credit Card', icon: HiOutlineCreditCard, library: 'heroicons' },
  { value: 'hi-calculator', label: 'Calculator', icon: HiOutlineCalculator, library: 'heroicons' },
  { value: 'hi-sun', label: 'Sun', icon: HiOutlineSun, library: 'heroicons' },
  { value: 'hi-moon', label: 'Moon', icon: HiOutlineMoon, library: 'heroicons' },
  { value: 'hi-truck', label: 'Truck', icon: HiOutlineTruck, library: 'heroicons' },
  { value: 'hi-paper-airplane', label: 'Plane', icon: HiOutlinePaperAirplane, library: 'heroicons' },
  { value: 'hi-scissors', label: 'Scissors', icon: HiOutlineScissors, library: 'heroicons' },
  { value: 'hi-paper-clip', label: 'Paperclip', icon: HiOutlinePaperClip, library: 'heroicons' },
  { value: 'hi-refresh', label: 'Refresh', icon: HiOutlineRefresh, library: 'heroicons' },
  { value: 'hi-zoom-in', label: 'Zoom In', icon: HiOutlineZoomIn, library: 'heroicons' },
  { value: 'hi-zoom-out', label: 'Zoom Out', icon: HiOutlineZoomOut, library: 'heroicons' },
  { value: 'hi-arrows-expand', label: 'Expand', icon: HiOutlineArrowsExpand, library: 'heroicons' },
  { value: 'hi-document-text', label: 'Text', icon: HiOutlineDocumentText, library: 'heroicons' },
  { value: 'hi-code', label: 'Code', icon: HiOutlineCode, library: 'heroicons' },
  { value: 'hi-hashtag', label: 'Hash', icon: HiOutlineHashtag, library: 'heroicons' },
  { value: 'hi-at-symbol', label: 'At Symbol', icon: HiOutlineAtSymbol, library: 'heroicons' },
  { value: 'hi-minus', label: 'Minus', icon: HiOutlineMinus, library: 'heroicons' },
  { value: 'hi-plus', label: 'Plus', icon: HiOutlinePlus, library: 'heroicons' },
  { value: 'hi-x', label: 'X', icon: HiOutlineX, library: 'heroicons' },
  { value: 'hi-check', label: 'Check', icon: HiOutlineCheck, library: 'heroicons' },
  
  // Material Design Icons
  { value: 'md-zap', label: 'Zap', icon: MdOutlineFlashOn, library: 'material' },
  { value: 'md-attach-money', label: 'Dollar', icon: MdOutlineAttachMoney, library: 'material' },
  { value: 'md-calendar-today', label: 'Calendar', icon: MdOutlineCalendarToday, library: 'material' },
  { value: 'md-person', label: 'User', icon: MdOutlinePerson, library: 'material' },
  { value: 'md-home', label: 'Home', icon: MdOutlineHome, library: 'material' },
  { value: 'md-settings', label: 'Settings', icon: MdOutlineSettings, library: 'material' },
  { value: 'md-info', label: 'Info', icon: MdOutlineInfo, library: 'material' },
  { value: 'md-star', label: 'Star', icon: MdOutlineStar, library: 'material' },
  { value: 'md-favorite', label: 'Heart', icon: MdOutlineFavorite, library: 'material' },
  { value: 'md-visibility', label: 'Eye', icon: MdOutlineVisibility, library: 'material' },
  { value: 'md-search', label: 'Search', icon: MdOutlineSearch, library: 'material' },
  { value: 'md-filter-list', label: 'Filter', icon: MdOutlineFilterList, library: 'material' },
  { value: 'md-grid-view', label: 'Grid', icon: MdOutlineGridView, library: 'material' },
  { value: 'md-view-list', label: 'List', icon: MdOutlineViewList, library: 'material' },
  { value: 'md-bar-chart', label: 'Bar Chart', icon: MdOutlineBarChart, library: 'material' },
  { value: 'md-pie-chart', label: 'Pie Chart', icon: MdOutlinePieChart, library: 'material' },
  { value: 'md-trending-up', label: 'Trending Up', icon: MdOutlineTrendingUp, library: 'material' },
  { value: 'md-error', label: 'Alert', icon: MdOutlineError, library: 'material' },
  { value: 'md-check-circle', label: 'Check', icon: MdOutlineCheckCircle, library: 'material' },
  { value: 'md-cancel', label: 'X Circle', icon: MdOutlineCancel, library: 'material' },
  { value: 'md-edit', label: 'Edit', icon: MdOutlineEdit, library: 'material' },
  { value: 'md-content-copy', label: 'Copy', icon: MdOutlineContentCopy, library: 'material' },
  { value: 'md-download', label: 'Download', icon: MdOutlineDownload, library: 'material' },
  { value: 'md-upload', label: 'Upload', icon: MdOutlineUpload, library: 'material' },
  { value: 'md-share', label: 'Share', icon: MdOutlineShare, library: 'material' },
  { value: 'md-lock', label: 'Lock', icon: MdOutlineLock, library: 'material' },
  { value: 'md-key', label: 'Key', icon: MdOutlineKey, library: 'material' },
  { value: 'md-storage', label: 'Database', icon: MdOutlineStorage, library: 'material' },
  { value: 'md-dns', label: 'Cloud', icon: MdOutlineDns, library: 'material' },
  { value: 'md-cloud', label: 'Cloud', icon: MdOutlineCloud, library: 'material' },
  { value: 'md-wifi', label: 'WiFi', icon: MdOutlineWifi, library: 'material' },
  { value: 'md-battery-6-bar', label: 'Battery', icon: MdOutlineBattery6Bar, library: 'material' },
  { value: 'md-lightbulb', label: 'Lightbulb', icon: MdOutlineLightbulb, library: 'material' },
  { value: 'md-camera-alt', label: 'Camera', icon: MdOutlineCameraAlt, library: 'material' },
  { value: 'md-videocam', label: 'Video', icon: MdOutlineVideocam, library: 'material' },
  { value: 'md-music-note', label: 'Music', icon: MdOutlineMusicNote, library: 'material' },
  { value: 'md-description', label: 'Document', icon: MdOutlineDescription, library: 'material' },
  { value: 'md-folder', label: 'Folder', icon: MdOutlineFolder, library: 'material' },
  { value: 'md-link', label: 'Link', icon: MdOutlineLink, library: 'material' },
  { value: 'md-open-in-new', label: 'External Link', icon: MdOutlineOpenInNew, library: 'material' },
  { value: 'md-email', label: 'Mail', icon: MdOutlineEmail, library: 'material' },
  { value: 'md-phone', label: 'Phone', icon: MdOutlinePhone, library: 'material' },
  { value: 'md-access-time', label: 'Clock', icon: MdOutlineAccessTime, library: 'material' },
  { value: 'md-gps-fixed', label: 'Target', icon: MdOutlineGpsFixed, library: 'material' },
  { value: 'md-security', label: 'Shield', icon: MdOutlineSecurity, library: 'material' },
  { value: 'md-workspace-premium', label: 'Award', icon: MdOutlineWorkspacePremium, library: 'material' },
  { value: 'md-card-giftcard', label: 'Gift', icon: MdOutlineCardGiftcard, library: 'material' },
  { value: 'md-work', label: 'Briefcase', icon: MdOutlineWork, library: 'material' },
  { value: 'md-credit-card', label: 'Credit Card', icon: MdOutlineCreditCard, library: 'material' },
  { value: 'md-calculate', label: 'Calculator', icon: MdOutlineCalculate, library: 'material' },
  { value: 'md-wb-sunny', label: 'Sun', icon: MdOutlineWbSunny, library: 'material' },
  { value: 'md-nightlight', label: 'Moon', icon: MdOutlineNightlight, library: 'material' },
  { value: 'md-directions-car', label: 'Car', icon: MdOutlineDirectionsCar, library: 'material' },
  { value: 'md-local-shipping', label: 'Truck', icon: MdOutlineLocalShipping, library: 'material' },
  { value: 'md-flight', label: 'Plane', icon: MdOutlineFlight, library: 'material' },
  { value: 'md-build', label: 'Build', icon: MdOutlineBuild, library: 'material' },
  { value: 'md-create', label: 'Create', icon: MdOutlineCreate, library: 'material' },
  { value: 'md-content-cut', label: 'Scissors', icon: MdOutlineContentCut, library: 'material' },
  { value: 'md-attach-file', label: 'File', icon: MdOutlineAttachFile, library: 'material' },
  { value: 'md-refresh', label: 'Refresh', icon: MdOutlineRefresh, library: 'material' },
  { value: 'md-zoom-in', label: 'Zoom In', icon: MdOutlineZoomIn, library: 'material' },
  { value: 'md-zoom-out', label: 'Zoom Out', icon: MdOutlineZoomOut, library: 'material' },
  { value: 'md-open-in-full', label: 'Maximize', icon: MdOutlineOpenInFull, library: 'material' },
  { value: 'md-close-fullscreen', label: 'Minimize', icon: MdOutlineCloseFullscreen, library: 'material' },
  { value: 'md-drag-indicator', label: 'Move', icon: MdOutlineDragIndicator, library: 'material' },
  { value: 'md-text-fields', label: 'Type', icon: MdOutlineTextFields, library: 'material' },
  { value: 'md-code', label: 'Code', icon: MdOutlineCode, library: 'material' },
  { value: 'md-tag', label: 'Hash', icon: MdOutlineTag, library: 'material' },
  { value: 'md-alternate-email', label: 'Mail', icon: MdOutlineAlternateEmail, library: 'material' },
  { value: 'md-remove', label: 'X', icon: MdOutlineRemove, library: 'material' },
  { value: 'md-add', label: 'Plus', icon: MdOutlineAdd, library: 'material' },
  { value: 'md-close', label: 'X', icon: MdOutlineClose, library: 'material' },
  { value: 'md-done', label: 'Check', icon: MdOutlineDone, library: 'material' },
];

const ICON_LIBRARIES = {
  lucide: {
    name: 'Lucide',
    icons: LUCIDE_ICONS,
  },
  fontawesome: {
    name: 'FontAwesome',
    icons: FA_ICONS,
  },
  reacticons: {
    name: 'React Icons',
    icons: REACT_ICONS,
  },

};

const ICON_OPTIONS = ICON_LIBRARIES.lucide.icons;

const PROJECT_FIELD_OPTIONS = [
  { field: 'actual_completion_date', label: 'Actual Completion Date' },
  { field: 'annual_kwh_usage', label: 'Annual kWh Usage' },
  { field: 'approved_grant_amount', label: 'Approved Grant Amount' },
  { field: 'assigned_biz_dev_rep_id', label: 'Assigned Biz Dev Rep ID' },
  { field: 'assigned_internal_pm_id', label: 'Assigned Internal PM ID' },
  { field: 'assigned_installer_partner_id', label: 'Assigned Installer Partner ID' },
  { field: 'assigned_installer_pm_id', label: 'Assigned Installer PM ID' },
  { field: 'assigned_investor_id', label: 'Assigned Investor ID' },
  { field: 'assigned_proposal_designer_id', label: 'Assigned Proposal Designer' },
  { field: 'assigned_sales_rep_id', label: 'Assigned Sales Rep ID' },
  { field: 'assigned_site_surveyor_id', label: 'Assigned Site Surveyor ID' },
  { field: 'battery_size_kwh', label: 'Battery Size (kWh)' },
  { field: 'building_type', label: 'Building Type' },
  { field: 'city', label: 'City' },
  { field: 'company', label: 'Company' },
  { field: 'company_address_autocomplete', label: 'Company Address Autocomplete' },
  { field: 'company_name', label: 'Company (Alt)' },
  { field: 'comments', label: 'Comments' },
  { field: 'commercial_type', label: 'Commercial Type' },
  { field: 'contact_email', label: 'Contact Email' },
  { field: 'contact_name', label: 'Contact Name' },
  { field: 'contact_phone', label: 'Contact Phone' },
  { field: 'contract_signed_date', label: 'Contract Signed Date' },
  { field: 'created_at', label: 'Created At' },
  { field: 'current_stage_id', label: 'Current Stage ID' },
  { field: 'daysInStage', label: 'Days in Stage' },
  { field: 'days_in_stage', label: 'Days in Stage (Alt)' },
  { field: 'days_since_last_change', label: 'Days Since Last Change' },
  { field: 'desired_margin', label: 'Desired Margin' },
  { field: 'eighty_percent_installer_payment_paid', label: '80% Installer Payment Paid' },
  { field: 'eighty_percent_installer_payment_paid_amount', label: '80% Installer Payment Paid Amount' },
  { field: 'eighty_percent_installer_payment_paid_date', label: '80% Installer Payment Paid Date' },
  { field: 'estimated_completion_date', label: 'Estimated Completion Date' },
  { field: 'estimated_system_size', label: 'Estimated System Size' },
  { field: 'finance_type', label: 'Finance Type' },
  { field: 'financier_name', label: 'Financier Name' },
  { field: 'financing_option', label: 'Financing Option' },
  { field: 'first_name', label: 'First Name' },
  { field: 'grant_approved', label: 'Grant Approved' },
  { field: 'has_unread_comments', label: 'Has Unread Comments' },
  { field: 'id', label: 'ID' },
  { field: 'installation_complete_date', label: 'Installation Complete Date' },
  { field: 'is_flipped_job', label: 'Is Flipped Job' },
  { field: 'last_name', label: 'Last Name' },
  { field: 'link_to_open_thrvye_cases', label: 'Link to Open Thrvye Cases' },
  { field: 'mailing_address_type', label: 'Mailing Address Type' },
  { field: 'module_manufacturer', label: 'Module Manufacturer' },
  { field: 'monthly_electric_bill', label: 'Monthly Electric Bill' },
  { field: 'mounting_type', label: 'Mounting Type' },
  { field: 'name', label: 'Project Name' },
  { field: 'notes', label: 'Notes' },
  { field: 'ntp_approved_date', label: 'NTP Approved Date' },
  { field: 'open_cases_in_thrvye', label: 'Open Cases in Thrvye' },
  { field: 'parcel_number', label: 'Parcel Number' },
  { field: 'payment_options', label: 'Payment Options' },
  { field: 'project_city', label: 'Project City' },
  { field: 'project_county', label: 'Project County' },
  { field: 'project_full_address', label: 'Project Full Address' },
  { field: 'project_manager', label: 'Project Manager' },
  { field: 'project_name', label: 'Project Name (Alt)' },
  { field: 'project_notes', label: 'Project Notes' },
  { field: 'project_state', label: 'Project State' },
  { field: 'project_status', label: 'Project Status' },
  { field: 'project_street', label: 'Project Street' },
  { field: 'project_type', label: 'Project Type' },
  { field: 'project_value', label: 'Project Value' },
  { field: 'project_zip_code', label: 'Project Zip Code' },
  { field: 'property_address', label: 'Property Address' },
  { field: 'property_address_autocomplete', label: 'Property Address Autocomplete' },
  { field: 'property_city', label: 'Property City' },
  { field: 'property_owner_name', label: 'Property Owner Name' },
  { field: 'property_owner_same_as_client', label: 'Property Owner Same As Client' },
  { field: 'property_state', label: 'Property State' },
  { field: 'property_zip', label: 'Property Zip' },
  { field: 'pto_completed_date', label: 'PTO Completed Date' },
  { field: 'pto_received_manual_date', label: 'PTO Received Manual Date' },
  { field: 'roof_type', label: 'Roof Type' },
  { field: 'sales_rep', label: 'Sales Rep' },
  { field: 'solar_trackers', label: 'Solar Trackers' },
  { field: 'stage_changed_at', label: 'Stage Changed At' },
  { field: 'state', label: 'State' },
  { field: 'status', label: 'Status' },
  { field: 'system_cost', label: 'System Cost' },
  { field: 'system_size', label: 'System Size' },
  { field: 'system_type', label: 'System Type' },
  { field: 'tax_benefit_eligible', label: 'Tax Benefit Eligible' },
  { field: 'team_id', label: 'Team ID' },
  { field: 'team_name', label: 'Team Name' },
  { field: 'thryve_credit_application_status', label: 'Thryve Credit Application Status' },
  { field: 'twenty_percent_installer_payment_paid', label: '20% Installer Payment Paid' },
  { field: 'twenty_percent_installer_payment_paid_amount', label: '20% Installer Payment Paid Amount' },
  { field: 'twenty_percent_installer_payment_paid_date', label: '20% Installer Payment Paid Date' },
  { field: 'updated_at', label: 'Updated At' },
  { field: 'utility_provider', label: 'Utility Provider' },
  { field: 'value', label: 'Value' },
  { field: 'booking_date_time', label: 'Booking Date' },
].sort((a, b) => a.label.localeCompare(b.label));

// Expanded mock data for robust preview
const MOCK_DATA = {
  project_name: 'Benedict LLC Commercial Project',
  name: 'Benedict LLC Commercial Project',
  company: 'Benedict LLC',
  company_name: 'Benedict LLC',
  address: '527 South 14th Street, Newark, NJ',
  project_street: '527 South 14th Street',
  project_city: 'Newark',
  city: 'Newark',
  project_state: 'NJ',
  state: 'NJ',
  project_zip: '07103',
  project_value: 250000,
  value: 250000,
  system_cost: 250000,
  system_size: 12.5,
  estimated_system_size: 12.5,
  days_in_stage: 2,
  daysInStage: 2,
  assigned_sales_rep_id: '123',
  team_id: 1,
  team_name: 'Sales Team Alpha',
  internal_pm: { first_name: 'Jane', last_name: 'Doe' },
  sales_rep: { first_name: 'John', last_name: 'Smith' },
  proposal_designer: { first_name: 'Sarah', last_name: 'Martinez' },
  creator: { first_name: 'Alice', last_name: 'Johnson' },
  installer_partner: { company_name: 'Solar Installers Inc.' },
  biz_dev_rep: { first_name: 'Bob', last_name: 'Brown' },
  payment_options: ['Cash', 'Finance'],
  mounting_type: ['Roof', 'Ground'],
  created_at: '2023-01-01T00:00:00Z',
  updated_at: '2023-01-10T00:00:00Z',
  stage_changed_at: '2023-01-08T00:00:00Z',
  monthly_electric_bill: 300,
  approved_grant_amount: 5000,
  battery_size_kwh: 10,
  has_unread_comments: true,
  is_flipped_job: false,
  grant_approved: true,
  tax_benefit_eligible: false,
  booking_date_time: '2024-01-15T14:30:00Z',
  avatar: 'CL',
};

export interface CardFieldConfig {
  field: string;
  label: string;
  icon?: string;
}

interface CardLayoutEditorProps {
  value: CardFieldConfig[];
  onChange: (fields: CardFieldConfig[]) => void;
  project?: any;
}

export function CardLayoutEditor({ 
  value,
  onChange,
  project
}: CardLayoutEditorProps) {
  const { toast } = useToast();
  const [open, setOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredIconOptions, setFilteredIconOptions] = useState(ICON_OPTIONS);
  const [iconSearchQuery, setIconSearchQuery] = useState('');
  const [iconDialogOpen, setIconDialogOpen] = useState<number | null>(null);
  const [activeIconLibrary, setActiveIconLibrary] = useState('lucide');
  const [faVisibleCount, setFaVisibleCount] = useState(60);
  const [faFiltered, setFaFiltered] = useState(FA_ICONS);
  const [lucideFiltered, setLucideFiltered] = useState(LUCIDE_ICONS);
  const [reactIconsVisibleCount, setReactIconsVisibleCount] = useState(60);
  const [reactIconsFiltered, setReactIconsFiltered] = useState(REACT_ICONS);

  // Filter icons based on search query and active library
  useEffect(() => {
    if (activeIconLibrary === 'fontawesome') {
      if (iconSearchQuery.trim() === '') {
        setFaFiltered(FA_ICONS);
      } else {
        setFaFiltered(
          FA_ICONS.filter(option =>
            option.value.toLowerCase().includes(iconSearchQuery.toLowerCase()) ||
            option.label.toLowerCase().includes(iconSearchQuery.toLowerCase())
          )
        );
      }
    } else if (activeIconLibrary === 'lucide') {
      if (iconSearchQuery.trim() === '') {
        setLucideFiltered(LUCIDE_ICONS);
      } else {
        setLucideFiltered(
          LUCIDE_ICONS.filter(option =>
            option.value.toLowerCase().includes(iconSearchQuery.toLowerCase()) ||
            option.label.toLowerCase().includes(iconSearchQuery.toLowerCase())
          )
        );
      }
    } else if (activeIconLibrary === 'reacticons') {
      if (iconSearchQuery.trim() === '') {
        setReactIconsFiltered(REACT_ICONS);
      } else {
        setReactIconsFiltered(
          REACT_ICONS.filter(option =>
            option.value.toLowerCase().includes(iconSearchQuery.toLowerCase()) ||
            option.label.toLowerCase().includes(iconSearchQuery.toLowerCase())
          )
        );
      }
    }
  }, [iconSearchQuery, activeIconLibrary]);

  const handleDragEnd = (result: DropResult) => {
    if (!result.destination) return;
    const reordered = Array.from(value);
    const [removed] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, removed);
    onChange(reordered);
  };

  const handleLabelChange = (idx: number, label: string) => {
    const updated = value.map((f, i) => (i === idx ? { ...f, label } : f));
    onChange(updated);
  };

  const handleIconChange = (idx: number, icon: string) => {
    const updated = value.map((f, i) => (i === idx ? { ...f, icon } : f));
    onChange(updated);
    setIconDialogOpen(null);
    setIconSearchQuery('');
  };

  const handleRemove = (idx: number) => {
    const updated = value.filter((_, i) => i !== idx);
    onChange(updated);
  };

  const handleAddField = (field: string) => {
    const def = PROJECT_FIELD_OPTIONS.find(f => f.field === field);
    if (!def) return;
    
    // Get default icon based on field name
    const getDefaultIcon = (fieldName: string) => {
      const iconMap: { [key: string]: string } = {
        'system_size': 'zap',
        'project_value': 'dollar-sign',
        'days_in_stage': 'calendar',
        'name': 'user',
        'company': 'building',
        'city': 'map-pin',
        'state': 'map-pin',
        'booking_date_time': 'calendar-days',
        'contact_name': 'user',
        'contact_email': 'mail',
        'contact_phone': 'phone',
        'project_full_address': 'map-pin',
        'estimated_completion_date': 'calendar',
        'actual_completion_date': 'calendar',
        'contract_signed_date': 'file-text',
        'installation_complete_date': 'check-circle',
        'pto_completed_date': 'award',
        'monthly_electric_bill': 'dollar-sign',
        'approved_grant_amount': 'gift',
        'battery_size_kwh': 'battery',
        'team_name': 'users',
        'sales_rep': 'user',
        'project_manager': 'user',
        'assigned_internal_pm_id': 'user',
        'assigned_sales_rep_id': 'user',
        'assigned_installer_partner_id': 'building',
        'utility_provider': 'zap',
        'roof_type': 'home',
        'mounting_type': 'settings',
        'module_manufacturer': 'factory',
        'system_type': 'zap',
        'finance_type': 'credit-card',
        'financier_name': 'building',
        'payment_options': 'credit-card',
        'property_owner_name': 'user',
        'parcel_number': 'hash',
        'project_notes': 'file-text',
        'comments': 'message-circle',
        'notes': 'file-text',
        'status': 'activity',
        'project_status': 'activity',
        'is_flipped_job': 'refresh-cw',
        'grant_approved': 'check-circle',
        'tax_benefit_eligible': 'percent',
        'has_unread_comments': 'message-circle',
        'open_cases_in_thrvye': 'alert-circle',
        'link_to_open_thrvye_cases': 'external-link',
        'eighty_percent_installer_payment_paid': 'check-circle',
        'twenty_percent_installer_payment_paid': 'check-circle',
        'thryve_credit_application_status': 'credit-card',
        'solar_trackers': 'sun',
        'annual_kwh_usage': 'zap',
        'desired_margin': 'percent',
        'system_cost': 'dollar-sign',
        'value': 'dollar-sign',
        'estimated_system_size': 'zap',
        'daysInStage': 'calendar',
        'days_since_last_change': 'clock',
        'stage_changed_at': 'calendar',
        'created_at': 'calendar',
        'updated_at': 'clock',
        'ntp_approved_date': 'check-circle',
        'eighty_percent_installer_payment_paid_date': 'calendar',
        'twenty_percent_installer_payment_paid_date': 'calendar',
        'eighty_percent_installer_payment_paid_amount': 'dollar-sign',
        'twenty_percent_installer_payment_paid_amount': 'dollar-sign',
        'pto_received_manual_date': 'calendar',
        'team_id': 'users',
        'id': 'hash',
        'pipeline_id': 'git-branch',
        'current_stage_id': 'git-branch',
        'assigned_biz_dev_rep_id': 'user',
        'assigned_installer_pm_id': 'user',
        'assigned_investor_id': 'user',
        'assigned_site_surveyor_id': 'user',
        'property_owner_same_as_client': 'user-check',
        'mailing_address_type': 'map-pin',
        'commercial_type': 'building',
        'building_type': 'building',
        'project_type': 'folder',
        'project_name': 'file-text',
        'project_city': 'map-pin',
        'project_county': 'map-pin',
        'project_state': 'map-pin',
        'project_street': 'map-pin',
        'project_zip_code': 'map-pin',
        'property_address': 'map-pin',
        'property_city': 'map-pin',
        'property_state': 'map-pin',
        'property_zip': 'map-pin',
        'company_address_autocomplete': 'map-pin',
        'property_address_autocomplete': 'map-pin',
        'first_name': 'user',
        'last_name': 'user',
        'project_address': 'map-pin',
        'street': 'map-pin',
        'zip': 'map-pin',
        'address': 'map-pin',
      };
      return iconMap[fieldName] || 'info';
    };
    
    const newField = { 
      field: def.field, 
      label: def.label, 
      icon: getDefaultIcon(def.field)
    };
    const updated = [...value, newField];
    onChange(updated);
    setOpen(false);
    setSearchQuery('');
  };

  const filteredOptions = PROJECT_FIELD_OPTIONS
    .filter(option => !value.some(f => f.field === option.field))
    .filter(option => 
      option.label.toLowerCase().includes(searchQuery.toLowerCase()) ||
      option.field.toLowerCase().includes(searchQuery.toLowerCase())
    );

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-medium text-foreground">Fields</h3>
        <Button
          variant="outline"
          onClick={() => setOpen(true)}
          className="w-[200px] justify-between"
        >
          Add Field
          <Plus className="ml-2 h-4 w-4" />
        </Button>
      </div>
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="fields">
          {(provided) => (
            <div ref={provided.innerRef} {...provided.droppableProps} className="space-y-2">
              {value.length === 0 ? (
                <div className="text-muted-foreground text-sm p-2">No fields selected. Use the buttons below to add fields.</div>
              ) : (
                value.map((f, i) => (
                  <Draggable key={f.field} draggableId={f.field} index={i}>
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        className={`flex items-center gap-2 bg-muted/50 rounded p-2 ${snapshot.isDragging ? 'opacity-70' : ''}`}
                      >
                        <div {...provided.dragHandleProps} className="flex-shrink-0">
                          <GripVertical className="h-4 w-4 cursor-grab text-muted-foreground hover:text-foreground" />
                        </div>
                        <Input
                          value={f.label}
                          onChange={e => handleLabelChange(i, e.target.value)}
                          className="flex-1 min-w-[200px]"
                        />
                        <Dialog open={iconDialogOpen === i} onOpenChange={(open) => {
                          if (!open) {
                            setIconDialogOpen(null);
                            setIconSearchQuery('');
                          }
                        }}>
                          <DialogTrigger asChild>
                            <Button
                              variant="outline"
                              size="sm"
                              className="w-10 h-8 p-0 flex-shrink-0"
                              onClick={() => setIconDialogOpen(i)}
                            >
                              {f.icon ? (
                                (() => {
                                  let IconComponent = null;
                                  if (f.icon?.endsWith('|fa')) {
                                    // Handle FontAwesome icons
                                    const faIcon = FA_ICONS.find(ic => f.icon?.replace('|fa', '') === ic.value);
                                    if (faIcon && typeof faIcon.icon === 'object' && 'iconName' in faIcon.icon) {
                                      IconComponent = () => <FontAwesomeIcon icon={faIcon.icon} className="h-4 w-4" />;
                                    } else {
                                      IconComponent = Info;
                                    }
                                  } else if (f.icon?.endsWith('|ri')) {
                                    // Handle React Icons
                                    const reactIcon = REACT_ICONS.find(ic => f.icon?.replace('|ri', '') === ic.value);
                                    IconComponent = reactIcon ? reactIcon.icon : Info;
                                  } else {
                                    // Handle Lucide icons (no suffix)
                                    const lucideIcon = LUCIDE_ICONS.find(opt => opt.value === f.icon);
                                    IconComponent = lucideIcon ? lucideIcon.icon : Info;
                                  }
                                  return <IconComponent className="h-4 w-4" />;
                                })()
                              ) : (
                                <Info className="h-4 w-4" />
                              )}
                            </Button>
                          </DialogTrigger>
                          <DialogContent className="w-96">
                            <DialogHeader>
                              <DialogTitle>Select Icon</DialogTitle>
                            </DialogHeader>
                            <div className="space-y-4">
                              <Tabs value={activeIconLibrary} onValueChange={lib => {
                                setActiveIconLibrary(lib);
                                if (lib === 'fontawesome') setFaVisibleCount(60);
                                if (lib === 'reacticons') setReactIconsVisibleCount(60);
                              }}>
                                <TabsList className="grid w-full grid-cols-3">
                                  <TabsTrigger value="lucide">Lucide</TabsTrigger>
                                  <TabsTrigger value="fontawesome">FontAwesome</TabsTrigger>
                                  <TabsTrigger value="reacticons">React Icons</TabsTrigger>
                                </TabsList>
                              </Tabs>
                              <Input className="h-10 border-gray-300 bg-gray-50 focus:bg-white" 
                                placeholder="Search icons..." 
                                value={iconSearchQuery}
                                onChange={(e) => {
                                  setIconSearchQuery(e.target.value);
                                }}
                                onFocus={() => {}}
                              />
                              <div className="text-xs text-muted-foreground">
                                {activeIconLibrary === 'fontawesome'
                                  ? `Showing ${faFiltered.length} of ${FA_ICONS.length} icons`
                                  : activeIconLibrary === 'reacticons'
                                  ? `Showing ${reactIconsFiltered.length} of ${REACT_ICONS.length} icons`
                                  : `Showing ${lucideFiltered.length} of ${LUCIDE_ICONS.length} icons`}
                              </div>
                              <div
                                className="max-h-64 overflow-y-auto"
                                onScroll={e => {
                                  if (activeIconLibrary === 'fontawesome') {
                                    const el = e.currentTarget;
                                    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10) {
                                      setFaVisibleCount(c => c + 60);
                                    }
                                  } else if (activeIconLibrary === 'reacticons') {
                                    const el = e.currentTarget;
                                    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10) {
                                      setReactIconsVisibleCount(c => c + 60);
                                    }
                                  }
                                }}
                              >
                                <div className="grid grid-cols-8 gap-1">
                                  {(activeIconLibrary === 'fontawesome'
                                    ? faFiltered.slice(0, faVisibleCount)
                                    : activeIconLibrary === 'reacticons'
                                    ? reactIconsFiltered.slice(0, reactIconsVisibleCount)
                                    : lucideFiltered
                                  ).map((option) => {
                                    return (
                                      <button
                                        key={option.value}
                                        onClick={() => {
                                          handleIconChange(i, option.value + (activeIconLibrary === 'fontawesome' ? '|fa' : activeIconLibrary === 'reacticons' ? '|ri' : ''));
                                        }}
                                        className="flex flex-col items-center justify-center p-2 cursor-pointer hover:bg-muted rounded transition-colors"
                                        title={option.label}
                                      >
                                        {activeIconLibrary === 'fontawesome' ? (
                                          <FontAwesomeIcon icon={option.icon as any} className="h-4 w-4" />
                                        ) : activeIconLibrary === 'reacticons' ? (
                                          <option.icon className="h-4 w-4" />
                                        ) : (
                                          <option.icon className="h-4 w-4" />
                                        )}
                                        <span className="text-[10px] mt-1 truncate w-12">{option.label}</span>
                                      </button>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          </DialogContent>
                        </Dialog>
                        <Tooltip>
                          <TooltipTrigger asChild>
                            <div className="flex-shrink-0">
                              <Info className="h-4 w-4 text-muted-foreground hover:text-foreground cursor-help" />
                            </div>
                          </TooltipTrigger>
                          <TooltipContent>
                            <p className="text-xs">Variable: {f.field}</p>
                          </TooltipContent>
                        </Tooltip>
                        <button type="button" onClick={() => handleRemove(i)} className="p-1 ml-auto flex-shrink-0">
                          <Trash2 className="h-4 w-4 text-destructive hover:text-destructive/80" />
                        </button>
                      </div>
                    )}
                  </Draggable>
                ))
              )}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-[425px]">
          <DialogHeader>
            <DialogTitle>Add Field</DialogTitle>
          </DialogHeader>
          <div className="py-4">
            <Input className="h-10 border-gray-300 bg-gray-50 focus:bg-white mb-4"
              placeholder="Search fields..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <div className="max-h-[300px] overflow-y-auto space-y-2">
              {filteredOptions.length === 0 ? (
                <div className="text-sm text-muted-foreground text-center py-2">
                  No fields found
                </div>
              ) : (
                filteredOptions.map((option) => (
                  <Button
                    key={option.field}
                    variant="ghost"
                    className="w-full justify-start"
                    onClick={() => handleAddField(option.field)}
                  >
                    {option.label}
                  </Button>
                ))
              )}
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export function CardLayoutEditorPreview({ fields, project }: { fields: CardFieldConfig[]; project?: any }) {
  const data = project || MOCK_DATA;
  const [pmData, setPmData] = useState<any>(null);

  // Fetch project manager data when component mounts or project changes
  useEffect(() => {
    const fetchProjectManager = async () => {
      if (data.assigned_internal_pm_id) {
        try {
          const { data: pm, error } = await supabase
            .from('users')
            .select('first_name, last_name')
            .eq('id', data.assigned_internal_pm_id)
            .single();

          if (error) {
            console.error('Error fetching project manager:', error);
            return;
          }

          setPmData(pm);
        } catch (error) {
          console.error('Error fetching project manager:', error);
        }
      }
    };

    fetchProjectManager();
  }, [data.assigned_internal_pm_id]);

  // Build address from available fields
  const address =
    data.address ||
    data.project_address ||
    [data.street, data.city, data.state, data.zip].filter(Boolean).join(', ') ||
    [data.project_street, data.project_city, data.project_state, data.project_zip].filter(Boolean).join(', ') ||
    data.city ||
    MOCK_DATA.address;

  // Get initials for avatar
  const avatar = (data.company || data.project_name || data.name || '').split(' ').map((w: string) => w[0]).join('').slice(0, 2).toUpperCase() || MOCK_DATA.avatar;

  // Helper to format values
  const getFieldValue = (field: string) => {
    if (!data) return '—';

    // Calculate days in stage
    if (['days_in_stage', 'daysInStage'].includes(field)) {
      if (data.stage_changed_at) {
        const stageChangedDate = new Date(data.stage_changed_at);
        const today = new Date();
        const diffTime = Math.abs(today.getTime() - stageChangedDate.getTime());
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return `${diffDays} days`;
      }
      return '—';
    }

    // Fallbacks for common fields
    if (['value', 'project_value', 'system_cost'].includes(field)) {
      const v = data.value ?? data.project_value ?? data.system_cost;
      return typeof v === 'number' ? `$${v.toLocaleString()}` : v || '—';
    }
    if (['system_size', 'estimated_system_size'].includes(field)) {
      const v = data.system_size ?? data.estimated_system_size;
      return typeof v === 'number' ? `${v} kW` : v || '—';
    }
    if (['company', 'company_name'].includes(field)) {
      return data.company || data.company_name || '—';
    }
    if (['project_name', 'name'].includes(field)) {
      return data.project_name || data.name || '—';
    }
    if (['city', 'project_city'].includes(field)) {
      return data.city || data.project_city || '—';
    }
    if (['state', 'project_state'].includes(field)) {
      return data.state || data.project_state || '—';
    }

    // Nested fields
    if (['project_manager', 'internal_pm'].includes(field)) {
      if (pmData) {
        return `${pmData.first_name || ''} ${pmData.last_name || ''}`.trim() || '—';
      }
      return '—';
    }

    // Handle assigned user IDs by showing names from relationship data
    if (field === 'assigned_sales_rep_id' && data.sales_rep) {
      return `${data.sales_rep.first_name || ''} ${data.sales_rep.last_name || ''}`.trim() || '—';
    }
    if (field === 'assigned_internal_pm_id' && data.internal_pm) {
      return `${data.internal_pm.first_name || ''} ${data.internal_pm.last_name || ''}`.trim() || '—';
    }
    if (field === 'assigned_proposal_designer_id' && data.proposal_designer) {
      return `${data.proposal_designer.first_name || ''} ${data.proposal_designer.last_name || ''}`.trim() || '—';
    }
    if (field === 'assigned_biz_dev_rep_id' && data.biz_dev_rep) {
      return `${data.biz_dev_rep.first_name || ''} ${data.biz_dev_rep.last_name || ''}`.trim() || '—';
    }
    if (field === 'assigned_installer_partner_id' && data.installer_partner) {
      return data.installer_partner.company_name || '—';
    }

    // Arrays
    if (field === 'payment_options' && Array.isArray(data.payment_options)) {
      return data.payment_options.join(', ') || '—';
    }
    if (field === 'mounting_type' && Array.isArray(data.mounting_type)) {
      return data.mounting_type.join(', ') || '—';
    }

    // Dates
    if (field.includes('_date') || field === 'created_at' || field === 'updated_at' || field === 'stage_changed_at') {
      const date = data[field];
      if (!date) return '—';
      return new Date(date).toLocaleDateString();
    }

    // Booking date time
    if (field === 'booking_date_time') {
      const date = data[field];
      if (!date) return '—';
      return new Date(date).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    }

    // Currency
    if ([
      'approved_grant_amount',
      'eighty_percent_installer_payment_paid_amount',
      'twenty_percent_installer_payment_paid_amount',
      'monthly_electric_bill',
    ].includes(field)) {
      const value = data[field];
      if (typeof value !== 'number') return '—';
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
    }

    // System size
    if (field === 'battery_size_kwh') {
      const value = data[field];
      if (typeof value !== 'number') return '—';
      return `${value} kWh`;
    }

    // Booleans
    if ([
      'has_unread_comments',
      'is_flipped_job',
      'eighty_percent_installer_payment_paid',
      'twenty_percent_installer_payment_paid',
      'grant_approved',
      'tax_benefit_eligible',
    ].includes(field)) {
      return data[field] ? 'Yes' : 'No';
    }

    // Default
    const value = data[field];
    if (value === undefined || value === null || value === '') return '—';
    return value.toString();
  };

  return (
    <Card className="w-[320px]">
      <CardContent className="p-4">
        <div className="flex items-start justify-between">
          <div>
            <div className="font-semibold text-base leading-tight mb-0.5">
              {data.project_name || data.name || MOCK_DATA.project_name}
            </div>
            <div className="text-xs text-muted-foreground mb-2">
              {address}
            </div>
          </div>
          <Avatar className="h-9 w-9 bg-muted text-muted-foreground ml-2">
            <AvatarFallback>{avatar}</AvatarFallback>
          </Avatar>
        </div>
        <div className="mt-3 space-y-1.5">
          {fields.map((f, i) => {
            let IconComponent = null;
            if (f.icon?.endsWith('|fa')) {
              const faIcon = FA_ICONS.find(ic => f.icon?.replace('|fa', '') === ic.value);
              if (faIcon && typeof faIcon.icon === 'object' && 'iconName' in faIcon.icon) {
                IconComponent = () => <FontAwesomeIcon icon={faIcon.icon} className="h-3.5 w-3.5 text-muted-foreground" />;
              } else {
                IconComponent = Info;
              }
            } else if (f.icon?.endsWith('|ri')) {
              const reactIcon = REACT_ICONS.find(ic => f.icon?.replace('|ri', '') === ic.value);
              IconComponent = reactIcon ? reactIcon.icon : Info;
            } else {
              const allIcons = LUCIDE_ICONS;
              IconComponent = allIcons.find(opt => opt.value === f.icon)?.icon || Info;
            }
            return (
              <div key={i} className="flex items-center gap-3 py-1 text-sm">
                <Tooltip>
                  <TooltipTrigger asChild>
                    <div className="flex items-center justify-center w-6 h-6 bg-muted rounded-md">
                      <IconComponent className="h-3.5 w-3.5 text-muted-foreground" />
                    </div>
                  </TooltipTrigger>
                  <TooltipContent>
                    <p>{f.label}</p>
                  </TooltipContent>
                </Tooltip>
                <span className="font-medium flex-1">
                  {getFieldValue(f.field)}
                </span>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
} 